import React, { useState } from 'react';
import { claimFirstAppearance } from '../../lib/paper';

const STAGGER_MS = 45;
const MAX_DELAY_MS = 300;

/**
 * Rises its child in, staggered by `index` — only the first time `id` is seen
 * this session, so refetches and remounts never replay it (as on mobile).
 */
export const EnterOnce: React.FC<{
  id: string;
  index?: number;
  className?: string;
  children: React.ReactNode;
}> = ({ id, index = 0, className = '', children }) => {
  const [first] = useState(() => claimFirstAppearance(id));
  return (
    <div
      className={`${first ? 'pb-rise' : ''} ${className}`}
      style={first ? { animationDelay: `${Math.min(index * STAGGER_MS, MAX_DELAY_MS)}ms` } : undefined}
    >
      {children}
    </div>
  );
};
